import { useEffect, useState } from "react";
import {
  Box,
  Stack,
  TextField,
  Button,
  InputAdornment,
  useTheme,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";

import { Strings } from "@app/constants";
import { useRequestState, useResponsive } from "@app/hooks";

import { ModelCard } from "./model-card";
import { IModelData } from "../types";
import { selectDeleteModelState, selectModelState } from "../selector";
import { model } from "../slice";
import { AddModelModal } from "./add-model";

const ModelPage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const [query, setQuery] = useState<string>("");
  const [openAddModel, setOpenAddModel] = useState(false);

  const { data } = useRequestState({
    stateSelector: selectModelState,
    errorShown: true,
  });

  useEffect(() => {
    dispatch(model());
  }, [dispatch]);

  const filteredBrands = (data || [])?.filter((brand: IModelData) =>
    brand?.name?.toLowerCase()?.includes(query?.toLowerCase())
  );

  const brands = query ? filteredBrands : data;
  const isMobile = useResponsive("down", "sm");

  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: "#fff",
        borderRadius: 1,
        minHeight: { xs: "auto", md: "calc(100vh - 64px)" },
        boxSizing: "border-box",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="space-between"
        mb={3}
        alignItems="center"
      >
        <TextField
          fullWidth
          placeholder="Search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Icon icon="mdi:magnify" />
              </InputAdornment>
            ),
            sx: { backgroundColor: "#fff" },
          }}
        />

        <Button
          variant="contained"
          size="large"
          sx={{
            borderRadius: 1,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
            width: { xs: "100%", sm: 150 },
          }}
          onClick={() => setOpenAddModel(true)}
        >
          {Strings.button.addModel}
        </Button>
      </Stack>

      <Stack
        direction={"row"}
        flexWrap={"wrap"}
        gap={2}
        alignItems={"center"}
        justifyContent={isMobile ? "center" : "start"}
      >
        {brands?.length > 0 &&
          brands.map((item: IModelData) => (
            <ModelCard key={item.id} item={item} />
          ))}
      </Stack>

      <AddModelModal
        open={openAddModel}
        onClose={() => setOpenAddModel(false)}
      />
    </Box>
  );
};

export { ModelPage };
